import { css, stack } from '@bts-web/utils-style-engine';

export const titleStyles = css({
  fontSize: 'headline.large_semi_bold',
  fontWeight: 'headline.large_semi_bold',
  letterSpacing: 'headline.large_semi_bold',
  lineHeight: 'headline.large_semi_bold',
  color: 'neutrals.text_primary',
  textAlign: 'center',
});

export const subtitleStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'neutrals.text_secondary',
  textAlign: 'center',
});

export const centeredContentStyles = stack({
  direction: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1',
  gap: 'small',
  marginBottom: 'extra_small',
});
